import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ROUTE_NAME } from "@/router";

import BasePage from "@/components/page/BasePage.vue";
import StartScreenInterface from "@/components/viewInterface/StartScreenInterface.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'StartScreen',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePage, { "empty-header": "" }, {
    default: _withCtx(() => [
      _createVNode(StartScreenInterface, {
        onLogin: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: _unref(ROUTE_NAME).LOGIN }))),
        onRegister: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: _unref(ROUTE_NAME).REGISTER_ADMIN })))
      })
    ]),
    _: 1
  }))
}
}

})